export const findById = (id, list) => list.find(item => item.id === id);

export const findIndexById = (id, list) =>
  list.findIndex(item => item.id === id);

export default {
  findById,
  findIndexById
};
